(function() {
	if (!window._fpEvent) window._fpEvent = [];

	// 50% scroll tracking
	var scroll50Fired = false;
	function checkScroll50() {
		var scrollY = window.scrollY || window.pageYOffset;
		var docHeight = Math.max(
			document.body.scrollHeight, document.documentElement.scrollHeight,
			document.body.offsetHeight, document.documentElement.offsetHeight,
			document.body.clientHeight, document.documentElement.clientHeight
		);
		var winHeight = window.innerHeight;
		var scrolled = (scrollY + winHeight) / docHeight;
		if (!scroll50Fired && scrolled > 0.5) {
			scroll50Fired = true;
			window._fpEvent.push(['eventConversion', { value: 'HP_Improve_Hero_Section_Scroll_50' }]);
		}
	}
	var scrollTimeout = null;
	window.addEventListener('scroll', function() {
		if (scrollTimeout) clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(checkScroll50, 100);
	}, { passive: true });

	// Chat widget click tracking
	function trackChatWidgetButton() {
		var widget = document.querySelector('chat-widget[instance-id="0"]');
		if (!widget || !widget.shadowRoot) return;
		var floatingButton = widget.shadowRoot.querySelector('.flex.cursor-pointer.items-center.justify-center.rounded-full');
		if (floatingButton && !floatingButton.__trackedByCertapetAB) {
			floatingButton.__trackedByCertapetAB = true;
			floatingButton.addEventListener('click', function() {
				window._fpEvent.push(['eventConversion', { value: 'HP_Improve_Hero_Section_Chatbot_Click' }]);
			});
		}
	}
	var chatInterval = setInterval(function () {
		var widget = document.querySelector('chat-widget[instance-id="0"]');
		if (widget && widget.shadowRoot) {
			trackChatWidgetButton();
			clearInterval(chatInterval);
		}
	}, 300);
	var observer = new MutationObserver(function () { trackChatWidgetButton(); });
	observer.observe(document.body, { childList: true, subtree: true });

	// CTA click tracking
	document.body.addEventListener('click', function(e) {
		var btn = e.target.closest('.btn');
		if (!btn) return;
		var span = btn.querySelector('.cta-text') || btn.querySelector('span');
		if (!span) return;
		var text = (span.textContent || '').trim().replace(/\s+/g, ' ').toLowerCase();
		if (text === 'start free screening') {
			window._fpEvent.push(['eventConversion', { value: 'HP_Improve_Hero_Section_Start_Free_Screening_Click' }]);
		} else if (text === 'get your esa letter') {
			window._fpEvent.push(['eventConversion', { value: 'HP_Improve_Hero_Section_ESA_Letter_Click' }]);
		}
	}, false);

	// CA vs US toggle
	function isCanadaVisitor() {
		try {
			var nav = navigator;
			if (nav.languages) {
				for (var i = 0; i < nav.languages.length; i++) {
					if (typeof nav.languages[i] === 'string' && nav.languages[i].toLowerCase().indexOf('ca') !== -1) {
						return true;
					}
				}
			}
			if (nav.language && nav.language.toLowerCase().indexOf('ca') !== -1) return true;
			if (Intl && Intl.DateTimeFormat) {
				var opt = Intl.DateTimeFormat().resolvedOptions();
				if (opt && opt.locale && opt.locale.toLowerCase().indexOf('ca') !== -1) return true;
				if (opt && opt.timeZone) {
					var tz = opt.timeZone.toLowerCase();
					var canadianZones = [
						'america/toronto', 'america/halifax', 'america/vancouver',
						'america/edmonton', 'america/winnipeg', 'america/st_johns',
						'america/iqaluit', 'america/whitehorse', 'america/dawson'
					];
					for (var z = 0; z < canadianZones.length; z++) {
						if (tz.indexOf(canadianZones[z]) !== -1) return true;
					}
				}
			}
		} catch (e) {}
		return false;
	}
	function getUserLocation(callback) {
		if (!navigator.geolocation) { callback(null); return; }
		navigator.geolocation.getCurrentPosition(
			function (pos) { callback(pos.coords); },
			function () { callback(null); },
			{timeout: 5000}
		);
	}
	function checkIfInCanada(lat, lon, callback) {
		fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat=' + encodeURIComponent(lat) + '&lon=' + encodeURIComponent(lon))
			.then(function(res){ return res.json(); })
			.then(function(data){
				var country = data.address && data.address.country_code;
				callback(country === 'ca');
			})
			.catch(function(){ callback(false); });
	}
	function isCanadaVisitorEnhanced() {
		try {
			if (window.FIGPII && window.FIGPII.clientInfo) {
				var figpiiMatch = window.FIGPII.clientInfo.getUserLocation();
				if (figpiiMatch && figpiiMatch.country && figpiiMatch.country === 'CA') {
					return Promise.resolve(true);
				}
			}
		} catch (e) {}
		if (isCanadaVisitor()) return Promise.resolve(true);
		return new Promise(function(resolve){
			getUserLocation(function(pos){
				if (!pos) return resolve(false);
				checkIfInCanada(pos.latitude, pos.longitude, resolve);
			});
		});
	}
	function toggleCanadaUsBullets() {
		var liCA = document.querySelector('#hp_improve_hero_section .hp-item-ca');
		var liUS = document.querySelector('#hp_improve_hero_section .hp-item-us');
		if (!liCA || !liUS) return;
		isCanadaVisitorEnhanced().then(function(isCA){
			if (isCA) {
				liCA.style.display = '';
				liUS.style.display = 'none';
			}
		});
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', toggleCanadaUsBullets);
	} else {
		toggleCanadaUsBullets();
	}
})();


